<template>
  <div id="poster-page">
    <b-modal :active.sync="syncModal" :width="640" scroll="keep">
            <div class="card">
                
                  <header class="modal-card-head">
                    <p class="modal-card-title">{{ $t('Poster.menuSync') }}</p>
                  </header>
                    <div class="modal-card-body">
                      <label for="spotSelection">{{ $t('Poster.selectSpot') }}</label>
                      <b-select name="spotSelection" v-model="selectedSpot">
          
                      <option v-for="spot in spots" :key="spot.spot_id" :value="spot.spot_id">{{ spot.hall_name }}</option>
                    
                    </b-select>
                      
                      <b-message type="is-info" style="margin-top:1rem;">{{ $t('Poster.checkTerminalNote') }}</b-message>

                       <b-button type="is-info" class="mt-2" style="margin-left:auto;" v-bind:class="{ isLoading: isSyncing }"
                @click="startsync()">{{ $t('Poster.sync') }}</b-button>
                    </div>
            </div>
        </b-modal>
    <h1 class="title is-2">{{ $t('Poster.title') }}</h1>
    <div class="card ">
      <div class="card-content">
        <div class="block">
          <div class="field mt-2">
            <h1 class="title is-4">{{ $t('Poster.authorization') }} </h1>
              <p class="note"><span v-html="$t('Poster.posterNote')"></span></p>
              <button v-if="this.place.integrations && this.place.integrations.includes('poster')" v-bind:class="{ isLoading: isLoading }" class="button is-info mt-2 " disabled
                @click="connectPoster()">{{ $t('Poster.authorized') }}</button>
              <button v-else v-bind:class="{ isLoading: isLoading }" class="button is-info mt-2"
                @click="connectPoster()">{{ $t('Poster.connectPoster') }}</button>
          </div>
        </div>
        </div>
  </div>
        <div class="field mt-2">
        <b-switch v-model="menuSync" :disabled="!place.integrations || !place.integrations.includes('poster')"
          @input="(value) => updateMenuSync(value)" name="switchRoundedSuccess"
          type="is-success">
        </b-switch>
          <label for="switchRoundedSuccess">{{ $t('Poster.syncMenu') }}</label>
        </div>
        <div class="field mt-2">
        <b-switch v-model="ordersPush" :disabled="!place.integrations || !place.integrations.includes('poster')"
          @input="(value) => updateOrdersPush(value)" 
          type="is-success">
        </b-switch>
         <label for="switchRoundedSuccess">{{ $t('Poster.sendOrders') }}</label>
        </div>

        <button v-if="this.place.integrations && this.place.integrations.includes('poster')" v-bind:class="{ isLoading: isLoading }" class="button is-info mt-2"
                @click="manualMenuSync()">{{ $t('Poster.syncManually') }}</button>
        
    
  </div>

</template>

<script>
        
import _ from "underscore";
import {
  mapActions,
  mapGetters
} from "vuex";
import api from "@/api";

export default {
  name: "Poster",
  components: {

  },
  props: [],
  computed: _.extend({},
    mapGetters({
      place: "getPlaceInfo"
    })
  ),

  data() {
    return {
      isLoading: false,
      menuSync: false,
      ordersPush: false,
      syncModal: false,
      spots: [{hall_name: "-", hall_id: "-1"}],
      selectedSpot: "-1",
      isSyncing: false
    }
  },

  methods: _.extend({}, mapActions(["populatePlaceInfo", "updatePlaceInfo"]), {
    connectPoster: function () {
      this.$buefy.dialog.confirm({
        message: this.$t('Poster.dialogConnectPosterMessage'),
        title: this.$t('Poster.title'),
        type: 'is-success',
        confirmText: this.$t('Dashboard.yes'),
        cancelText: this.$t('Dashboard.back'),
        onConfirm: () => {
          this.$ma.trackEvent({
            category: 'event',
            action: 'Connection with Poster started',
            label: null,
            value: null
          })

          window.open(`https://joinposter.com/api/auth?application_id=1378&redirect_uri=https://create.savemenu.ru/poster&response_type=code`, "_self")
        },
        onCancel: () => {
          this.$ma.trackEvent({
            category: 'event',
            action: 'Connection with Poster cancelled',
            label: null,
            value: null
          });
        }
      })

    },
    startsync() {
      this.isSyncing = true
     api.posterSyncMenu({url: this.place.url, spot: this.selectedSpot}).then(()=>{
        this.$cognitoAuth.refreshSession(options => {
          this.populatePlaceInfo(options).then(() => {
            
            if (this.place.integrations) {
              if (!this.place.integrations.includes("poster"))
                this.place.integrations.push("poster")
            }
            else this.place.integrations = ["poster"]
            
            if (this.place.ordering.integrations) {
              if (!this.place.ordering.integrations.includes("poster"))
                this.place.ordering.integrations.push("poster")
            }
            else this.place.ordering.integrations = ["poster"]
            
            this.updatePlaceInfo(this.place)
            this.$forceUpdate()
            this.ordersPush = true
            this.menuSync = true
            this.isSyncing = true
            this.syncModal = false
            this.$buefy.dialog.alert({
            type: 'is-success',
            message: "Интеграция с Poster произведена успешно. </br> Меню синхронизировано.",
            onConfirm: () => {this.$router.replace('/')}
          })

          })          
        });
        });
    },
    manualMenuSync() {
      this.isLoading = true
      api.posterSyncMenu({url: this.place.url}).then((response) => {
        this.isLoading = false
      })
    },
    saveInfo() {
      this.updatePlaceInfo(this.place).then(() => {
        this.$buefy.toast.open(this.$t('DashboardTable.saved'))
      });
    },
    updateMenuSync(value) {
      if (value)
        this.place.menuSync = 'poster'
      else
        this.place.menuSync = 'NA'
      this.saveInfo()
    },
    updateOrdersPush(value) {
      if (value && !this.place.ordering.integrations.includes('poster'))
        this.place.ordering.integrations.push('poster')
      else
      if (this.place.ordering.integrations.includes('poster'))
        this.place.ordering.integrations.splice(this.place.ordering.integrations.indexOf('poster'), 1)
      this.saveInfo()
    }
  }),
  mounted() {
    window.onbeforeunload = function () {}
    this.$ma.trackEvent({
      category: 'event',
      action: 'Page viewed: ' + this.$route.fullPath,
      label: null,
      value: null
    })

    //If redirected back from after Poster auth
    if (window.location.href.indexOf("account=") > -1) {
       this.isLoading = true
      let code = this.$route.query.code
      let account = this.$route.query.account
      console.log(code)
      api.connectPostman({
        code: code,
        url: this.place.url,
        account: account
      }).then((response) => {
        if (response.data.spotsId && response.data.spotsId.length > 0) {
          console.log(response)
          this.isLoading = false
          this.spots = response.data.spotsId
          this.selectedSpot = this.spots[0].spot_id
          this.syncModal = true
        }
        else {
          this.$buefy.toast.open("Синхронизация неудачна")
          
        }
      })
    } else {
      if (this.place.ordering.integrations && this.place.ordering.integrations.includes('poster'))
        this.ordersPush = true
      if (this.place.menuSync && this.place.menuSync == 'poster')
        this.menuSync = true
    }
  }
};
</script>
